const common = {
  'site.name': '清文華泉',
  'site.tagline': '把清華系知識出版，帶進繁體中文閱讀。',
  'site.brand_position': '清華系知識書與繁中學科閱讀品牌',
  'nav.home': '首頁',
  'nav.about': '品牌介紹',
  'nav.topics': '主題探索',
  'nav.blog': '閱讀專欄',
  'nav.books': '書籍資料庫',
  'nav.stores': '合作通路',
  'nav.faq': 'FAQ',
  'cta.explore_topics': '探索主題',
  'cta.browse_books': '瀏覽書籍',
  'cta.reading_guide': '閱讀指南',
  'cta.learn_more': '了解更多',
  'hero.title': '把清華系知識出版，帶進繁體中文閱讀。',
  'hero.subtitle': '清文華泉聚焦科普、理工、資訊科技、經管人文、生物醫學與彩色知識書，透過繁體中文出版與書籍資料整理，讓高品質知識內容被更多讀者理解、收藏與使用。',
  'hero.auxiliary': '知識有源頭，閱讀有路徑。',
  'brand.title': '清文華泉，清華系知識書的繁中閱讀入口。',
  'brand.description': '清文華泉以清華系知識出版內容為核心，出版方向涵蓋科普、理工、資訊科技、經管人文、生物醫學、文化藝術與彩色知識書。品牌重視知識的系統性、可讀性與繁體中文讀者的閱讀需求，讓專業內容不只是被引進，也能被整理、理解與長期使用。',
  'topics.heading': '依學科探索知識閱讀',
  'topics.description': '清文華泉依照學科與閱讀需求整理書籍內容，協助讀者從科普、理工、資訊科技、經管人文、生物醫學與彩色知識書中，找到適合自己的知識入口。',
  'new_releases.heading': '最新出版',
  'new_releases.view_all': '瀏覽全部書籍',
  'reading_guide.heading': '學科閱讀指南',
  'reading_guide.description': '依照學科領域整理閱讀路徑與推薦書單，幫助讀者建立系統性的知識架構。',
  'color_books.heading': '彩色知識書專區',
  'color_books.description': '以豐富的視覺語言呈現複雜概念，讓知識不再抽象。彩色圖像、圖解與 AIGC 輔助內容，開啟全新的閱讀體驗。',
  'popular_articles.heading': '熱門文章',
  'popular_articles.read_more': '閱讀全文',
  'book_search.heading': '書籍搜尋',
  'book_search.placeholder': '搜尋書名、作者或關鍵字...',
  'book_search.advanced': '進階搜尋',
  'stores.heading': '合作通路',
  'stores.description': '清文華泉出版品可透過以下通路平台購買。歡迎前往各平台搜尋「清文華泉」找到更多書籍。',
  'faq.heading': '常見問題',
  'songbo.heading': '崧博出版',
  'songbo.description': '清文華泉為崧博出版事業有限公司旗下品牌。若您想了解崧博出版的完整出版服務、版權合作、電子書製作、POD 按需印刷與合作通路平台發行，歡迎前往崧博出版官方網站。',
  'songbo.cta': '前往崧博出版官網',
  'footer.disclaimer': '清文華泉不是北京清華大學出版社官方網站，而是崧博出版事業有限公司旗下品牌。部分書籍依法取得授權後出版繁體中文版。',
  'footer.songbo_link': '崧博出版事業有限公司',
};

export default common;